import { IAppState } from 'src/app/redux/store/reducers';
import { IErrorValidation } from 'src/app/data/common/interfaces/IRestError';

export const getValidationErrors = (state: IAppState): IErrorValidation[] => state.sso.error.validations;